import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { DialogTitle, Avatar } from '@mui/material';
import StatusEstabelecimento from '../../utils/status/statusEstabelecimentoBusca';
import { useNavigate, useParams } from 'react-router-dom';
import Loading from '../../load/loading';
import api from '../../services/api';
import { makeStyles } from '@material-ui/core/styles';
import RegisterAccess from '../../utils/registerAccess';

const useStyles = makeStyles((theme) => ({
    fundo: {
        minHeight: '70vh',
        backgroundImage: 'url(/img/logo/logoArmed.svg)',
        backgroundSize: 'cover',
        // backgroundPosition: 'end',
        opacity: 0.1,
        // position: 'absolute',
        width: '100%',
        padding: 40
    },
    altura: { minHeight: '70vh' }
}))

function SimpleDialog(props) {
    const { open } = props;
    // const handleClose = () => { onClose('') };
    const navigate = useNavigate()

    return (
        <Dialog fullWidth open={open} scroll='body' >
            {props.estabelecimento &&
                <DialogTitle mb={2}>
                    <Button color='error' title="fechar" style={{ position: 'absolute', right: 5, fontWeight: 'bold' }} onClick={() => navigate('/')}> <CloseIcon /></Button>
                </DialogTitle>
            }

            {props.expediente ?
                <>

                    <Typography style={{ lineHeight: 1.5, margin: 10 }} align="center" variant="body1">
                        Nº de Registo {props.expediente?.numero}
                    </Typography>

                    <Typography style={{ lineHeight: 1.5, margin: 10 }} align="center" variant="body1">
                        Tipo de Documento:
                        <br />
                        {props.expediente?.tipoDocumento?.designacao}
                    </Typography>

                    <Typography style={{ lineHeight: 1.5, margin: 10 }} align="center" variant="body1">
                        Rquerente:
                        <br />
                        {props.expediente?.nome}
                    </Typography>

                    <StatusEstabelecimento status={props.expediente?.status} />
                </>
                :
                <div style={{ padding: 20 }}>
                    <Typography style={{ lineHeight: 1 }} align="center" variant="subtitle1">
                        Documento não reconhecido pela ARMED
                    </Typography>

                    <Button style={{ marginTop: 20 }} size='small' fullWidth color='error' onClick={() => navigate('/')}>Fechar</Button>
                </div>
            }
        </Dialog>
    );
}

SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export default function ConsultaExpediente() {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [expediente, setExpediente] = React.useState('');
    const handleClose = () => { setOpen(false) };
    const { idExpediente } = useParams()

    React.useEffect(() => {
        api.get(`/expediente/${idExpediente}`)
            .then(response => {
                // console.log(response)
                setExpediente(response.data.expediente);
            }).catch(error => {
                // console.log(error)
                // if (error.response.status === 500) {
                //     setMessageError('Reclamação não encontrada')
                //     window.setTimeout(() => {
                //         navigate(-1)
                //     }, 1000);
                // }
            })
    }, [idExpediente])

    return (
        <div className={open ? classes.fundo : classes.altura} >
            <RegisterAccess page={'consultor de expediente'} />
            {open ?
                <SimpleDialog
                    open={open}
                    onClose={handleClose}
                    expediente={expediente}
                />
                :
                <Loading text={'A verificar expediente.'} />
            }
        </div>
    );
}
